import { SearchPart } from "@components/Pages/Machines/Search/Search.props";
import {
  MinersSelectionI,
  ActionSelect,
  ActionTypesMinersSelect,
  SelectedMinerI,
  ActionAdd,
  ActionRemove,
  ActionSelectAll,
  SelectionQuery,
  ActionRemoveAll,
  ActionSetShownMiners,
  ActionAddShownMiners,
  RequestParamsI,
  ActionSetRequestParams,
  ActionReorderShownMiners,
  ActionScrollTo,
  ActionResetScroll,
  ActionSetDrag,
  ActionSetTab,
  ActionNeedDeselect,
  ActionSetSubTabNum,
  ActionSetSubTabs,
  ActionSetDragOverTab,
  Tab,
} from "./actionTypes";
import { useDispatch } from "react-redux";
import useApiRequests from "@services/http/useApiRequest";

export function selectMiners(selection: MinersSelectionI): ActionSelect {
  return {
    type: ActionTypesMinersSelect.SELECT,
    payload: selection,
  };
}

export function addSelectedMiners(miners: SelectedMinerI[]): ActionAdd {
  return {
    type: ActionTypesMinersSelect.ADD,
    payload: miners,
  };
}

export function removeSelectedMiners(toRemove: SelectedMinerI[]): ActionRemove {
  return {
    type: ActionTypesMinersSelect.REMOVE,
    payload: toRemove.map((m) => m.id),
  };
}

export function selectAllMiners(
  query: SelectionQuery,
  total: number,
  page?: SelectedMinerI[]
): ActionSelectAll {
  return {
    type: ActionTypesMinersSelect.SELECT_ALL,
    payload: {
      page,
      query,
      total,
    },
  };
}

export function removeAllSelectedMiners(): ActionRemoveAll {
  return { type: ActionTypesMinersSelect.REMOVE_ALL };
}

export function setShownSelectedMiners(
  miners: SelectedMinerI[],
  total: number,
  received: number
): ActionSetShownMiners {
  return {
    type: ActionTypesMinersSelect.SET_SHOWN,
    payload: { miners, total, received },
  };
}

export function addShownSelectedMiners(
  miners: SelectedMinerI[],
  total: number,
  received: number
): ActionAddShownMiners {
  return {
    type: ActionTypesMinersSelect.ADD_SHOWN,
    payload: { miners, total, received },
  };
}

export function reorderShownSelectedMiners(
  miners: SelectedMinerI[]
): ActionReorderShownMiners {
  return {
    type: ActionTypesMinersSelect.REORDER_SHOWN,
    payload: miners,
  };
}

export function setRequestParams(
  params: RequestParamsI
): ActionSetRequestParams {
  return {
    type: ActionTypesMinersSelect.SET_REQUEST_PARAMS,
    payload: params,
  };
}

export function scrollTo(minerID: number): ActionScrollTo {
  return {
    type: ActionTypesMinersSelect.SCROLL_TO,
    payload: minerID,
  };
}

export function resetScroll(): ActionResetScroll {
  return {
    type: ActionTypesMinersSelect.RESET_SCROLL,
  };
}

export function setDrag(fromTab: number, minerIDs?: string[]): ActionSetDrag {
  return {
    type: ActionTypesMinersSelect.SET_DRAG,
    payload: {
      ids: minerIDs,
      fromTab,
    }
  }
}

export function setTab(tabID: number): ActionSetTab {
  return {
    type: ActionTypesMinersSelect.SET_TAB,
    payload: tabID,
  }
}

export function setSubTabNum(tabID: number): ActionSetSubTabNum {
  return {
    type: ActionTypesMinersSelect.SET_SUBTAB_NUM,
    payload: tabID,
  }
}

export function setSubTabs(parts: SearchPart[]): ActionSetSubTabs {
  return {
    type: ActionTypesMinersSelect.SET_SUBTABS,
    payload: parts,
  }
}

export function needDeselectAll(v: boolean): ActionNeedDeselect {
  return {
    type: ActionTypesMinersSelect.NEED_DESELECT,
    payload: v,
  };
}

export const useMinersSelectActions = () => {
  const dispatch = useDispatch();

  const initUserTabs = async () => {

  };

  return {
    initUserTabs,
  };
}

export const setDragOverTab = (tab?: Tab): ActionSetDragOverTab => ({
  type: ActionTypesMinersSelect.SET_DRAG_OVER_TAB,
  payload: tab,
});